<template>
  <div class="flex">
      <AdminPanel>
        <h1 class="mb-4">Additional Options Pricing</h1>
        <div>
          <div class="mx-4 flex flex-col">
            <div :key="option.name" v-for="option in addlOptions" class="mt-4 flex flex-col">
              <h2>{{ option.label }}</h2>
              <div :key="`${option.name}-${tier}`" v-for="tier in Object.keys(option.tiers)" class="flex justify-center items-center">
                <div class="mr-2">
                  {{ tier }}
                </div>
                <div>
                  <MoneyInput :ref="`${option.name}-${tier}`" :tier="tier" :initValue="option.tiers[tier]"></MoneyInput>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4" @click="save">
            <JButton :label="saveText" :isWhite="false"></JButton>
          </div>
        </div>
      </AdminPanel>
    </div>
</template>

<script>
import JButton from '@/components/JButton'
import AdminPanel from '@/components/AdminPanel'
import MoneyInput from '@/components/MoneyInput'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  name: 'ChangeAddlOptionsPricing',
  components: { AdminPanel, MoneyInput, JButton },
  data () {
    return {
      saveText: 'Save',
      addlOptions: []
    }
  },
  async mounted () {
    if (this.addlOptions.length === 0) {
      const options = (await firebase.firestore().collection(`addlOptions`).get()).docs
      for (let option of options) {
        option = option.data()
        option.tiers = (await firebase.firestore().doc(`pricing/${option.name}`).get()).data()
        this.addlOptions.push(option)
      }
    }

    return this.addlOptions
  },
  methods: {
    async save () {
      this.saveText = 'Saving...'
      for (let ref of Object.keys(this.$refs)) {
        if (ref.includes('-')) {
          const optionName = ref.split('-')[0]
          const optionInput = this.$refs[ref][0]
          const tier = optionInput.getTier()
          const value = optionInput.getValue()
          const updateObject = {}
          updateObject[tier] = value
          await firebase.firestore().doc(`pricing/${optionName}`).update(updateObject)
        }
      }
      this.saveText = 'Saved!'
    }
  }
}
</script>
